import styled from 'styled-components'

export default styled.div`
  font-weight: normal;
  display: flex;
  margin-bottom: 5px;
`



// WEBPACK FOOTER //
// ./src/components/DashboardWidgets/UsersActivity/Row/Wrapper.js